import {NotFoundPage} from '@common/ui/not-found-page/not-found-page';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {redirect, RouteObject} from 'react-router';

// Languages configured at /admin/localizations. On a multilingual site custom
// pages live at the locale-prefixed root URL /{locale}/{slug}; with none
// configured they keep the legacy /pages/{slug} form.
const configuredLocales: string[] = (
  getBootstrapData()?.i18n?.locales ?? []
).map(l => l.language);
const activeLocale =
  getBootstrapData()?.i18n?.active || configuredLocales[0] || 'en';

// Custom-page routes. Multilingual: serve each locale's pages at
// /{locale}/:pageSlug and 301-style redirect the legacy /pages/... client URLs
// to the active locale (the backend canonicalises the slug on a hard load).
// Monolingual: keep rendering at the legacy /pages/... paths.
const pageRoutes: RouteObject[] = configuredLocales.length
  ? [
      {
        path: 'pages/:pageSlug',
        loader: ({params}) => redirect(`/${activeLocale}/${params.pageSlug}`),
      },
      {
        path: 'pages/:pageId/:pageSlug',
        loader: ({params}) => redirect(`/${activeLocale}/${params.pageSlug}`),
      },
      ...configuredLocales.map(locale => ({
        path: `${locale}/:pageSlug`,
        lazy: () => import('@common/custom-page/custom-page-layout'),
      })),
    ]
  : [
      {
        path: 'pages/:pageSlug',
        lazy: () => import('@common/custom-page/custom-page-layout'),
      },
      {
        path: 'pages/:pageId/:pageSlug',
        lazy: () => import('@common/custom-page/custom-page-layout'),
      },
    ];

export const commonRoutes: RouteObject[] = [
  {
    path: 'contact',
    lazy: () => import('@common/contact/contact-us-page'),
  },
  ...pageRoutes,
  {
    path: '404',
    element: <NotFoundPage />,
  },
];
